import { LinksCardProps } from './links-card.component';

interface ViewProps {
    privacyDocumentFile?: { blob: Blob; url: string } | null;
}

export const useLinksCard = (props: LinksCardProps): ViewProps => {
    return {
        privacyDocumentFile: props.privacyDocumentFile
    };
};
